import React, { useEffect, useState } from 'react';
const headlines = ['Gehen oder bleiben?', 'Was steckt noch alles in Ihnen und wie können Sie Ihre Potenziale einsetzen?', 'Welcher Job passt wirklich?', 'Hamsterrad oder Karriereleiter? Sie wollen wieder mehr Zufriedenheit im Job?', 'Sie möchten besser kommunizieren oder konstruktiver mit Konflikten umgehen?'];
export const KarriereCoachingPage: React.FC = () => {
  const [currentHeadline, setCurrentHeadline] = useState(0);
  const [fadeState, setFadeState] = useState<'visible' | 'fading'>('visible');
  useEffect(() => {
    const interval = setInterval(() => {
      setFadeState('fading');
      setTimeout(() => {
        setCurrentHeadline(prev => (prev + 1) % headlines.length);
        setFadeState('visible');
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <section className="w-full bg-white py-16 px-6 md:px-12 lg:px-20" data-id="element-406">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-407">
          <div data-id="element-408">
            <h1 className="text-3xl md:text-4xl text-orange-500 font-light mb-6 transition-opacity duration-500" style={{
            opacity: fadeState === 'visible' ? 1 : 0,
            minHeight: '120px'
          }} data-id="element-409">
              {headlines[currentHeadline]}
            </h1>
          </div>
          <div className="flex justify-center" data-id="element-410">
            <img src="https://cdn.magicpatterns.com/uploads/9Y8EKcYB6zAJc3w1t5v66R/Eva-Schifferer-Coaching-Karriere.png" alt="Karriere Coaching Würfel" className="max-h-80 object-contain" data-id="element-411" />
          </div>
        </div>
      </section>

      <section className="w-full text-white py-16 px-6 md:px-12 lg:px-20" style={{
      backgroundColor: '#545454'
    }} data-id="element-412">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-413">
          <div data-id="element-414">
            <h2 className="text-2xl md:text-3xl text-orange-500 font-light mb-8" data-id="element-415">
              Mit personal branding eigene Stärken kennen und sich authentisch
              positionieren ohne sich „verkaufen" zu müssen.
            </h2>
          </div>
          <div data-id="element-416">
            <p className="mb-6 text-base leading-relaxed" data-id="element-417">
              Die eigenen Stärken zu kennen und sie zielsicher einzusetzen ist
              der Königsweg für Zufriedenheit im Job.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-418">
              Mehr Optionen in unserer heutigen Berufswelt bringen mehr
              Unsicherheit – oft verbunden mit der Frage: was ist der richtige
              passende nächste Schritt? Im Karriere Coaching erhalten Sie
              Antworten auf Ihre Fragen und Sicherheit über die nächsten
              Schritte.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-419">
              Mit meinem „personal branding" erarbeiten wir, was Sie besonders
              auszeichnet und wie Sie sich authentisch und erfolgreich im
              Unternehmen oder am Markt positionieren. Erstaunlicherweise kennen
              nur wenige Menschen Ihre wirklichen Stärken gut. Dabei bieten
              diese eine sehr gute Entscheidungsgrundlage, um heraus zu finden
              was gut zu Ihnen passt.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-420">
              Beim Training neuer Verhaltensweisen bspw. in der Klärung und
              Lösung von Konflikten arbeiten wir mit einem strukturierten
              Ansatz, mit dem Sie schnellen Wandel spüren können.
            </p>
            <p className="mb-6 text-base leading-relaxed" data-id="element-421">
              Lassen Sie uns darüber sprechen und nehmen Sie Kontakt auf!
            </p>
            <a href="/kontakt" className="inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition-colors" data-id="element-422">
              Lassen Sie uns sprechen
            </a>
          </div>
        </div>
      </section>
    </>;
};